import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import { route as searchRoute } from "@faire/web-api--source/routes/www/search";
import { useLocation } from "react-router-dom";
export var useIsSearchPage = function() {
    var location = useLocation();
    return pathMatchesRoute(location, searchRoute);
};
